import {poll} from '@yourcoach/async-utils';

import type {Expand} from '../../types';

import {envManager} from '../../../utils/env';
import {foodShareExpandCommon} from '../../foodDiary/foodShare';
import {userExpandCommon} from '../../user';

const formExpand: Expand = {
  form: ['avatar_id'],
};

const boundFormExpand: Expand = {
  bound_form: [
    ['author_id', {name: 'User not found'}, userExpandCommon],
    ['form_id', null, formExpand],
    'resource_id',
  ],
};

export const attachmentExpandCommon: Expand = {
  bound_form: boundFormExpand.bound_form,
  conference: ['course_id'],
  material: ['file_ids'],
  questionnaire: ['avatar_id'],
  user: ['avatar_id'],
};

const attachmentExpandKey = 'attachment_ids->expandedAttachments';

const postExpand: Expand = {
  post: [
    ['user_id', {name: 'User not found'}, userExpandCommon],
    [attachmentExpandKey, null, attachmentExpandCommon],
  ],
};

// a function that patch an expand of post attachments
const patchPostAttachmentsExpand = (expand: Expand, patch: Expand) => {
  const attachmentExpandIndex = expand.post!.findIndex(
    e => e[0] === attachmentExpandKey,
  );
  const attachmentExpand = expand.post![attachmentExpandIndex]!;

  const expandToPatch = attachmentExpand[2];

  if (expandToPatch) {
    Object.assign(expandToPatch, patch);
  }
};

const postExpandWithReply = JSON.parse(JSON.stringify(postExpand)) as Expand;

// replies are posts inside a post attachments
// we need to expand them
patchPostAttachmentsExpand(postExpandWithReply, {
  post: postExpand.post,
});

export {postExpandWithReply as postExpandCommon};

poll(
  () => envManager.isReady,
  () => {
    if (envManager.isCore) {
      attachmentExpandCommon.food_share = foodShareExpandCommon.food_share;

      patchPostAttachmentsExpand(postExpandWithReply, {
        food_share: foodShareExpandCommon.food_share,
      });
    }
  },
);
